export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const ROLE_LOADING = 'ROLE_LOADING';
export const GET_ROLE_SUCCESS = 'GET_ROLE_SUCCESS';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
